// removed by extract-text-webpack-plugin
module.exports = {"heading":"_JjTnln"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/Search/components/SearchBar/components/ClassificationList/ClassificationList.less
 ** module id = 897
 ** module chunks = 0
 **/